import { render, staticRenderFns } from "./icon_only_toggle.vue.js?vue&type=template&id=6472cc45!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./icon_only_toggle.vue?vue&type=template&id=6472cc45"
import script from "./icon_only_toggle.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./icon_only_toggle.vue?vue&type=script&lang=js"
export * from "./icon_only_toggle.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./icon_only_toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6472cc45')) {
      api.createRecord('6472cc45', component.options)
    } else {
      api.reload('6472cc45', component.options)
    }
    module.hot.accept("./icon_only_toggle.vue.js?vue&type=template&id=6472cc45!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./icon_only_toggle.vue?vue&type=template&id=6472cc45", function () {
      api.rerender('6472cc45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/icon_only_toggle.vue"
export default component.exports